<template>
  <v-app style="background: transparent">
    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <site-title :title="site.title"></site-title>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="drawerMessage=!drawerMessage" icon>
        <site-message :drawer="drawerMessage"></site-message>
      </v-btn>
      <site-sign :site="site"></site-sign>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed app disable-resize-watcher :width="drawerSize">
      <site-menu :items="site.menu"></site-menu>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="drawerMessage" app right>
      <message room="public" :drawer="drawerMessage"></message>
    </v-navigation-drawer>
    <v-content class="mb-6">
      <site-banner :text="site.banner"></site-banner>

      <v-container fluid>
        <v-alert type="warning" border="left" dismissible>
          <p>안녕하세요 memi입니다. 이 사이트는 시연용 사이트입니다.</p>
          <p>이 사이트는 추후 폐쇄될 예정이므로..</p>
          <p>실제 강의가 진행되고 있는 <a href="https://memi.dev" target="_blank">https://memi.dev</a> 에서 확인하세요~</p>
          <p>그럼 memi.dev에서 뵙겠습니다~ <v-icon>mdi-emoticon</v-icon></p>
          <v-card-actions>
            <!-- <v-spacer/> -->
            <v-btn href="https://memi.dev" target="_blank" color="primary"><v-icon left>mdi-arrow-right-drop-circle</v-icon>바로가기</v-btn>
          </v-card-actions>

        </v-alert>
        <router-view />
      </v-container>
    </v-content>
    <site-footer :text="site.footer"></site-footer>
  </v-app>
</template>

<script>
import SiteTitle from '@/views/site/title'
import SiteBanner from '@/views/site/banner'
import SiteMenu from '@/views/site/menu'
import SiteFooter from '@/views/site/footer'
import SiteSign from '@/views/site/sign'
import SiteMessage from '@/views/site/message'
import Message from '@/views/message/'

export default {
  components: { SiteTitle, SiteBanner, SiteMenu, SiteFooter, SiteSign, SiteMessage, Message },
  name: 'App',
  data () {
    return {
      drawer: false,
      site: {
        title: '',
        banner: '',
        footer: '',
        menu: [
          {
            icon: 'mdi-home-circle',
            active: true,
            title: '홈',
            subItems: [
              {
                title: '요약',
                to: '/'
              }
            ]
          }
        ]
      },
      drawerMessage: false,
      loading: false
    }
  },
  computed: {
    drawerSize () {
      let size
      if (this.$store.state.editable) {
        if (!this.$vuetify.breakpoint.xs) size = 500
        else size = 320
      } else {
        size = 300
      }
      return size
    }
  },
  created () {
    // this.subscribe()
  },
  destroyed () {
    const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : 'default'
    this.$firebase.database().ref().child('sites').child(uid).off()
  },
  watch: {
    '$store.state.loaded' (n, o) {
      this.subscribe()
    }
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    subscribe () {
      const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : 'default'
      this.loading = true
      this.$firebase.database().ref().child('sites').child(uid).on('value', (sn) => {
        this.loading = false
        const v = sn.val()
        if (!v) return
        if (!v.menu) v.menu = []
        this.site = v
        this.$store.commit('setSite', v)
      }, this.onError)
    }
  }
}
</script>
